<template>
  <div class="flex flex-wrap w-full p-0 m-0">
    <div class="lg:w-5/12 lg:pr-2">
      <p>Votre réponse</p>
      <ul class="p-0 py-1 m-0 text-lg list-none">
        <li class="pt-1.5 flex flex-wrap" v-for="(a, idx) in answer.choices">
          <div
            class="flex flex-wrap items-center flex-shrink-0 pr-1 answer-status"
          >
            <div
              class="flex items-center justify-center w-2 h-2 mx-0.5 text-black bg-white rounded answer-icon"
            >
              <div
                class="w-2 h-2 pt-0.25 text-sm text-center align-middle rounded-full"
              >
                {{ idx + 1 }}
              </div>
            </div>
          </div>
          <span class="flex-1"> {{ answerTitle(a) }}</span>
        </li>
      </ul>
    </div>
    <div class="lg:border-l lg:w-7/12 lg:pl-2">
      <p>La bonne réponse</p>
      <div v-html="question.answer"></div>
      <ul class="p-0 py-1 m-0 text-lg list-none">
        <li
          class="pt-1.5 flex flex-wrap"
          v-for="(question_answer, idx) in question.answers"
        >
          <div
            class="flex flex-wrap items-center flex-shrink-0 pr-1 answer-status"
          >
            <div
              class="flex items-center justify-center w-2 h-2 mx-0.5 rounded answer-icon text-black"
            >
              <div
                class="w-2 h-2 pt-0.25 text-sm text-center align-middle rounded-full"
                :class="{
                  'bg-green': hasCorrectPosition(idx),
                  'bg-corail': !hasCorrectPosition(idx),
                }"
              >
                {{ question_answer.position + 1 }}
              </div>
              <!-- <CheckIcon class="w-1 h-1" v-if="answer.valid" />
              <CloseIcon class="w-1 h-1" v-if="!answer.valid" /> -->
            </div>
          </div>
          <span class="flex-1" v-html="question_answer.title"></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import CheckIcon from "./icons/CheckIcon.vue";
import CloseIcon from "./icons/CloseIcon.vue";
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  answer: {
    type: Object,
    required: true,
  },
});
const answerTitle = (id) => {
  const a = props.question.answers.find((e) => e.id == id);
  if (a) return a.title;
};
const correctOrder = () => {
  return props.question.answers.map((el) => el.id);
};
const hasCorrectPosition = (idx) => {
  return props.answer.choices[idx] == props.question.answers[idx].id;
};
</script>
